<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <TemplateAttachment
          ref="templateAttachment"
          :disabled="row.templateStatus == 'N'"
          :multipleDisabled="false"
          :templateCode="row.templateCode"
        />
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_view') || '查看'"
          placement="top"
        >
          <i
            class="el-icon-view tool-btn"
            @click="
              $emit('openEditFormDialog', {
                type: 'detail',
                row,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_edit') || '编辑'"
          placement="top"
          v-if="allow('M')"
        >
          <i
            class="el-icon-edit tool-btn"
            v-if="row.templateStatus == 'Y'"
            @click="
              $emit('openEditFormDialog', {
                type: 'edit',
                row,
              })
            "
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_downloada') || '下载'"
          placement="top"
        >
          <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="allow('D')"
        >
          <i
            class="el-icon-delete tool-btn"
            v-if="row.templateStatus == 'Y'"
            @click="del(row)"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:templateThumbnailUrl="{ row }">
        <el-image
          :src="
            row.templateThumbnailUrl
              ? $osscdn(row.templateThumbnailUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
          :preview-src-list="[
            row.templateThumbnailUrl
              ? $osscdn(row.templateThumbnailUrl)
              : '/image/static/img/nopic.jpg',
          ]"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.templateStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.v_templateStatus }}
        </el-tag>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns.js'
import TemplateAttachment from '../edit-form/templateAttachment'
export default {
  mixins: [TableAutoHeight],
  components: { TemplateAttachment },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    del(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .sysInoutTemplateDelApi({
            templateCode: row.templateCode,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || res.msg,
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    downloadFile({ templateFileCode = '' }) {
      this.$api.SYS_FILEDOWNLOAD(templateFileCode)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-table .vxe-body--expanded-cell {
    padding: 5px;
  }
}
</style>
